<template>
  <Countdown v-if="diff" class="text-14px leading-22px flex min-w-80px" :time="diff">
    <template slot-scope="{ days, hours, minutes, seconds }">
      <b class="font-rubik font-medium">
        {{ days * 24 + hours }}:{{ String(minutes).padStart(2, '0') }}:{{ String(seconds).padStart(2, '0') }}
      </b>
    </template>
  </Countdown>
</template>

<script>
import Countdown from '@chenfengyuan/vue-countdown';

export default {
  name: 'OrderCountdown',
  props: {
    diff: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  components: {
    Countdown,
  },
};
</script>
